import {
  Clock, ArrowRight, ShieldCheck, CheckCircle2, XCircle,
  Archive, AlertTriangle, Box,
} from 'lucide-react';

export const TASK_TYPES = [
  '店铺安全巡检',
  '广告分析',
  'Listing优化',
  '图片需求生成',
  '视频需求生成',
  '库存/货件处理',
  'Case/申诉处理',
  'Creator红人合作',
  '促销/价格活动',
  '其他',
];

export const STATUSES = [
  { key: 'pending', label: '待处理', color: 'bg-slate-100 text-slate-700 border-slate-200', icon: Clock },
  { key: 'processing', label: '处理中', color: 'bg-blue-50 text-blue-700 border-blue-200', icon: ArrowRight },
  { key: 'review', label: '待审核', color: 'bg-amber-50 text-amber-700 border-amber-200', icon: ShieldCheck },
  { key: 'completed', label: '已完成', color: 'bg-emerald-50 text-emerald-700 border-emerald-200', icon: CheckCircle2 },
  { key: 'rejected', label: '已驳回', color: 'bg-rose-50 text-rose-700 border-rose-200', icon: XCircle },
  { key: 'archived', label: '已归档', color: 'bg-gray-100 text-gray-600 border-gray-200', icon: Archive },
  { key: 'overdue', label: '已超时', color: 'bg-orange-50 text-orange-700 border-orange-200', icon: AlertTriangle },
];

export const PRIORITIES = [
  { key: 'urgent', label: '紧急', color: 'bg-rose-500 text-white' },
  { key: 'high', label: '高', color: 'bg-orange-500 text-white' },
  { key: 'medium', label: '中', color: 'bg-blue-500 text-white' },
  { key: 'low', label: '低', color: 'bg-slate-400 text-white' },
];

export const SITES = ['US', 'CA', 'MX', 'UK', 'DE', 'FR', 'IT', 'ES', 'JP', 'AU', 'AE', 'SG', 'IN'];
export const STORES = ['Store-A', 'Store-B', 'Store-C', 'Store-D', 'Store-E'];
export const USERS = ['Leo', 'Alice', 'Bob', 'Carol', 'David', 'Eve', '当前用户'];

export const ROLES = {
  admin: { key: 'admin', label: '管理员', canEditAll: true, canApprove: true, canDeleteAny: true, canArchive: true, canConfigLLM: true },
  writer: { key: 'writer', label: '写作人', canEditOwn: true, canEditAssigned: true, canApprove: false, canDeleteOwn: true, canArchive: false, canConfigLLM: false },
  reviewer: { key: 'reviewer', label: '审批人', canEditAll: false, canApprove: true, canDeleteAny: false, canArchive: true, canConfigLLM: false },
};

export const NAV_ITEMS = [
  { key: 'dashboard', label: '概览看板', icon: Box },
  { key: 'create', label: '创建任务', icon: null },
  { key: 'all', label: '全部任务', icon: null },
  { key: 'mine', label: '我的任务', icon: null },
  { key: 'leo', label: '审批中心', icon: null },
  { key: 'logs', label: '操作日志', icon: null },
  { key: 'charts', label: '统计图表', icon: null },
  { key: 'settings', label: '系统配置', icon: null },
];

export const TASK_SCHEMA_VERSION = '2.0.0';

export const LLM_PRESETS = [
  { name: 'OpenAI GPT-4', baseUrl: 'https://api.openai.com/v1', model: 'gpt-4', temperature: 0.7, maxTokens: 4096 },
  { name: 'OpenAI GPT-4o', baseUrl: 'https://api.openai.com/v1', model: 'gpt-4o', temperature: 0.7, maxTokens: 4096 },
  { name: 'Claude 3.5 Sonnet', baseUrl: 'https://api.anthropic.com/v1', model: 'claude-3-5-sonnet-20241022', temperature: 0.5, maxTokens: 8192 },
  { name: 'DeepSeek V3', baseUrl: 'https://api.deepseek.com/v1', model: 'deepseek-chat', temperature: 0.7, maxTokens: 4096 },
  { name: '通义千问', baseUrl: 'https://dashscope.aliyuncs.com/api/v1', model: 'qwen-max', temperature: 0.7, maxTokens: 4096 },
];

export const LOG_TYPES = [
  { key: 'create', label: '创建', color: 'bg-emerald-100 text-emerald-700' },
  { key: 'edit', label: '编辑', color: 'bg-blue-100 text-blue-700' },
  { key: 'status', label: '状态变更', color: 'bg-amber-100 text-amber-700' },
  { key: 'approve', label: '审批', color: 'bg-purple-100 text-purple-700' },
  { key: 'delete', label: '删除', color: 'bg-rose-100 text-rose-700' },
  { key: 'attachment', label: '附件', color: 'bg-indigo-100 text-indigo-700' },
  { key: 'comment', label: '评论', color: 'bg-cyan-100 text-cyan-700' },
  { key: 'batch', label: '批量操作', color: 'bg-orange-100 text-orange-700' },
];
